import { tv } from "tailwind-variants";

interface IProps {
  videoLocation: string;
}

const styles = tv({ base: "min-f-full hidden h-auto max-w-full md:flex" });

const OnboardingVideo = ({ videoLocation }: IProps) => {
  const base = styles();

  return (
    <video
      data-testid="onboarding-video"
      className={base}
      autoPlay
      controls
      loop
      muted>
      <source src={videoLocation} type="video/mp4" />
    </video>
  );
};

export default OnboardingVideo;
